import { Broadcast } from '@phosphor-icons/react';

export default Broadcast;
